<div class="page-header">
    <div class="page-header__wrapper">
        <div class="page-header__bg">
            <div class="page-header__gradient"></div>
        </div>
        <header>
            <ul class="page-header__elements">
                <li class="home-link">
                    <a [routerLink]="linkHome()">
                        <img src="/icon-192-inv.png" />
                        {{ title() }}
                    </a>
                </li>
                <li>
                    <a matButton="elevated" class="mat-raised-button--tertiary" [routerLink]="linkDonate()">Spenden</a>
                </li>
            </ul>
            <div (click)="pageHeaderToggleMenu($event)" class="page-header__menu-button">
                <svg width="20" height="20" viewBox="0 0 20 20"
                    [class]="{'page-header__menu-icon': true, 'page-header__menu-icon--active': menuActive}">
                    <title>
                        dots
                    </title>
                    <circle cx="10" cy="10" r="2" />
                    <circle cx="3" cy="10" r="2" />
                    <circle cx="17" cy="10" r="2" />
                </svg>
            </div>
            <div [class]="{'page-header__menu': true, 'page-header__menu--active': menuActive}"
                (click)="headerMenuClicked($event)">
                <ul class="page-header__menu-navigation">
                    @for(elem of navigationElements(); track $index) {
                    <li class="page-header__menu-element">
                        @if(!isMenuElementSameSite(elem)) {
                        <a matButton="text" class="mat-text-button--big"
                            [routerLink]="getNavElementUrl(elem)">{{getNavElementUrlText(elem)}}</a>
                        }
                        @if(isMenuElementSameSite(elem)) {
                        <div #headerMenuElementSameSite>
                            <button matButton="text" class="mat-text-button--big"
                                (click)="pageHeaderToggleMenu($event)">
                                {{getNavElementUrlText(elem)}}
                            </button>
                        </div>
                        }
                    </li>
                    }
                </ul>
            </div>
        </header>
    </div>
</div>